import React from 'react';
import { NextPage } from 'next';
import Layout from '../../../components/layout';
import AccountLayout from '../../../components/account-layout';
import AccountSigninForm from '../../../components/@account-auth/account-signin-form';

const SigninPage: NextPage = () => (
  <Layout title="Sign In" description="Sign in to your account.">
    <AccountLayout
      title="Sign In"
      breadcrumb={{ url: '/', text: 'Back to home' }}
    >
      <AccountSigninForm />
    </AccountLayout>
  </Layout>
);

export default SigninPage;
